// Identity validation configuration
// Maximum number of attempts for all validation methods
// This value must match the backend configuration
export const MAX_VALIDATION_ATTEMPTS = 3;
